import { CalendarCheck, CheckCircle2, Flame, Sparkles, Zap } from 'lucide-react';

const BADGES = [
  { id: 'closer', label: 'Closer', Icon: CheckCircle2, cls: 'bg-emerald-400/10 text-emerald-300 border-emerald-300/30', hint: 'At least 1 paid conversion', test: (x) => x.paid >= 1 },
  { id: 'booker', label: 'Booker', Icon: CalendarCheck, cls: 'bg-sky-400/10 text-sky-300 border-sky-300/30', hint: 'At least 1 consultation booked', test: (x) => x.consultations >= 1 },
  { id: 'hot-streak', label: 'Hot streak', Icon: Flame, cls: 'bg-rose-400/10 text-rose-300 border-rose-300/30', hint: '3+ registrations in this period', test: (x) => x.registrations >= 3 },
  { id: 'assessment-pro', label: 'Assessment pro', Icon: Sparkles, cls: 'bg-indigo-400/10 text-indigo-300 border-indigo-300/30', hint: '70%+ of their students took the assessment (min 3 registrations)', test: (x) => x.registrations >= 3 && x.assessment_rate >= 70 },
  { id: 'first-steps', label: 'First steps', Icon: Zap, cls: 'bg-amber-400/10 text-amber-300 border-amber-300/30', hint: 'First registration in this period', test: (x) => x.registrations >= 1 && x.registrations < 3 },
];

export const BADGE_LEGEND = BADGES;

export const Badges = ({ x, center = false }) => {
  const earned = BADGES.filter((b) => b.test(x));
  if (!earned.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${center ? 'justify-center' : ''}`}>
      {earned.map(({ id, label, Icon, cls, hint }) => (
        <span key={id} title={hint} className={`inline-flex items-center gap-1 whitespace-nowrap rounded-full border px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${cls}`} data-testid={`badge-${id}-${x.code}`}>
          <Icon className="w-3 h-3" />{label}
        </span>
      ))}
    </div>
  );
};

export const Stat = ({ label, value }) => (
  <span className="text-[11px] text-slate-500"><span className="font-semibold text-slate-800">{value}</span> {label}</span>
);
